<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Career - Create Job</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                label="Divisi"
                v-model="careerData.division_id"
                :options="optionEmploymentDivision"
                vertical
                @input="handleEmploymentDivision"
              />
            </CCol>
            <CCol :col="6">
              <CSelect
                label="Lokasi"
                :options="optionLocation"
                vertical
                v-model="careerData.city"
                @input="handleLocation"
                placeholder="Select Lokasi"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Posisi"
                class="mb-0"
                v-model="careerData.job_position"
                vertical
                placeholder="Posisi"
              />
            </CCol>
            <CCol :col="6">
              <CSelect
                label="Job Level"
                :options="optionJobLevel"
                v-model="careerData.job_level"
                vertical
                @input="handleJobLevel"
                placeholder="Select Job Level"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                label="Employment Type"
                :options="optionEmploymentGroup"
                v-model="careerData.employment_type"
                vertical
                @input="handleEmploymentType"
                placeholder="Employment Group"
              />
            </CCol>
            <CCol :col="6">
              <CSelect
                label="Employment Status"
                :options="optionEmploymentStatus"
                v-model="careerData.employment_status"
                vertical
                @input="handleEmploymentStatus"
                placeholder="Employment Status"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6" >
              <CTextarea
                label="Meta Description"
                class="mb-0"
                type="text"
                vertical
                v-model="careerData.meta_info_description"
                placeholder="Meta Description"
              />
            </CCol>
            <CCol :col="6" >
              <CTextarea
                label="Meta Keyword"
                class="mb-0"
                type="text"
                vertical
                v-model="careerData.meta_info_keyword"
                placeholder="Meta Keyword"
              />
            </CCol>
          </CRow>
          <CRow
            class="form-group"
            v-if="careerData.employment_type === 'Walk-in-Interview'"
          >
            <CCol :col="6">
              <CInput
                label="Tempat Acara"
                class="mb-0"
                v-model="careerData.place"
                vertical
                placeholder="Tempat Acara"
              ></CInput>
            </CCol>
          </CRow>
          <CRow
            class="form-group"
            v-if="careerData.employment_type === 'Walk-in Interview'"
          >
            <CCol :col="6">
              <CInput
                label="Tanggal"
                class="mb-0"
                type="date"
                v-model="date"
                vertical
                placeholder="Tanggal"
              />
            </CCol>
            <CCol
              :col="6"
              v-if="careerData.employment_type === 'Walk-in Interview'"
            >
              <CInput
                label="waktu"
                class="mb-0"
                type="text"
                v-model="time"
                placeholder="00:00"
              />
            </CCol>
          </CRow>
          <CRow
            class="form-group"
            v-if="careerData.employment_type === 'Walk-in Interview'"
          >
            <CCol :col="12">
              <p>Harus Membawa</p>
              <vue-editor
                class="mt-2"
                v-model="content3"
                :editor-toolbar="customToolbar"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <p>Job Description</p>
              <vue-editor
                class="mt-2"
                v-model="content"
                :editor-toolbar="customToolbar"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <p>Minimum Qualifications</p>
              <vue-editor
                class="mt-2"
                v-model="content2"
                :editor-toolbar="customToolbar"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol
              :col="3"
              v-if="careerData.employment_type === 'Walk-in Interview'"
            >
              <CInput
                label="Quota"
                class="mb-0"
                type="number"
                v-model="careerData.quota"
                vertical
                placeholder="Quota"
              />
            </CCol>
            <CCol :col="3">
              <CSelect
                label="Status"
                :options="optionStatus"
                v-model="careerData.status"
                vertical
                @input="handleStatus"
                placeholder="Pilih"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="updateCareer"
                >Submit</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import jwt from "jsonwebtoken";
import moment from "moment";
import { VueEditor } from "vue2-editor";
import DivisionUseCase from '../app/usecase/division';

export default {
  components: { VueEditor },
  name: "JobCreate",

  data() {
    return {
      careerData: {},
      date: "2020-10-01",
      time: "",
      typeE: "",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      optionLocation: [],
      content: "",
      content2: "",
      content3: "",
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ header: 1 }, { header: 2 }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ direction: "rtl" }],
        ["clean"],
      ],
      optionEmploymentDivision: [],
      optionJobLevel: ["Intern", "Staff", "Supervisor", "Manager", "Director", "Executive"],
      optionEmploymentGroup: ["Reguler", "Walk-in Interview"],
      optionEmploymentStatus: ["Full Time", "Part Time", "Intern"],
      optionStatus: ["ACTIVE", "INACTIVE"],
    };
  },
  mounted() {
    this.authentication();
    this.getDataByID();
    this.getLocation();
    this.getDivision();
  },
  methods: {
    async getDivision() {
      try {
        const { data, err } = await DivisionUseCase.getAll("page=1&per_page=100&status=ACTIVE");
        if (err || data.data.length == 0) {
          this.err = err;
        } else {
          if (data) {
            this.optionEmploymentDivision = data.data.map(a => {
              return {
                value: a.division_id,
                label: a.division_name
              }
            }).sort((a, b) => a.label.localeCompare(b.label))
          }
        }
      }
      catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    getLocation() {
      axios
        .get(`${this.domain}/v1/location/province/data`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.optionLocation = response.data.data.map(a => a.province_name).sort();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getDataByID() {
      let careerID = this.$route.params.id;
      axios
        .get(`${this.domain}/v1/career/${careerID}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.

          this.careerData = response.data;
          var date = new Date(this.careerData.datetime_event);
          var dateMoment = moment(
            date.getFullYear() +
              "-" +
              (date.getMonth() + 1) +
              "-" +
              date.getDate()
          ).format("YYYY-MM-DD");
          this.date = dateMoment;
          this.time = date.getHours() + ":" + date.getMinutes();
          this.content = this.careerData.job_description;
          this.content2 = this.careerData.min_qualification;
          this.content3 = this.careerData.note;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "HRD" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/career/job" });
    },

    handleLocation(event) {
      this.careerData.city = event.target.value;
    },
    handleJobLevel(event) {
      this.careerData.job_level = event.target.value;
    },
    handleEmploymentType(event) {
      this.careerData.employment_type = event.target.value;
      this.type = event.target.value;
    },
    handleEmploymentStatus(event) {
      this.careerData.employment_status = event.target.value;
    },
    handleStatus(event) {
      this.careerData.status = event.target.value;
    },
    handleEmploymentDivision(event) {
      this.careerData.division_id = event.target.value;
    },
    updateCareer() {
      let careerID = this.$route.params.id;
      var dateEvent = moment(this.date + " " + this.time).format();
      this.careerData.quota = Number(this.careerData.quota);
      if (this.careerData.employment_type === "Walk-in-Interview") {
        this.careerData.datetime_event = dateEvent;
      }
      this.careerData.job_description = this.content;
      this.careerData.min_qualification = this.content2;
      this.careerData.note = this.content3;
      delete this.careerData.division_name;
      axios
        .put(`${this.domain}/v1/career/${careerID}`, this.careerData, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          Swal.fire({
            icon: "success",
            title: `Job Updated`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.items = response.data;
          this.$router.push({ path: `/career/job` });
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: err.response.data.message.id,
          });
        });
    },
  },
};
</script>

<style scoped>
@import "./Job.css";
</style>
